import React, { useEffect, useState } from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/background-img.png";
import ProductImage from "../../assets/images/productimg.jpg";
import "../../assets/styles/contact.css";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { config } from "../config";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

const Index = () => {
    const [product_details, setProductDetails] = useState([]);
    const [product, setProduct] = useState([]);
    const { slug } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(
                    // `http://localhost/elementeers_crm/api/product_details/${slug}`
                    `https://admin.elementeers.com/api/product_details/${slug}`
                );
                console.log(response.data.product_details);
                setProductDetails(response.data.product_category);
                setProduct(response.data.product_details);
            } catch (err) {
                setError("Failed to fetch product details.");
            } finally {
                setLoading(false);
            }
        };

        fetchBlog();
    }, [slug]);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalPages = Math.ceil(product.length / itemsPerPage);
    const displayedData = product.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    useEffect(() => window.scrollTo(0, 0), [])

    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
    return (
        <div>
            <Helmet>
                <title>Product Details - Elementeers Nucleons</title>
            </Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title={product_details.name}
            />

            <div className="">
                <div className="contact-info-area pb-80 pt-80 bg-f9f6f6">
                    <div className="container">
                        <div className="row justify-content-center">

                            <div className="col-lg-4 col-md-6">
                                <img src={`${config.imageUrl}/product/categories/${product_details.detail_image}`} style={{ width: "100%" }} alt="Product image" />
                            </div>
                            <div className="col-lg-8 col-md-6 py-4 px-4 d-flex align-items-center">
                                <p dangerouslySetInnerHTML={{ __html: product_details.description }}></p>
                            </div>

                        </div>

                    </div>
                </div>
                <div className="contact-info-area pb-80">
                    <div className="container">
                        <div className="row pt-80 scr-table">
                            <div className="flex justify-between items-center mb-4">
                                <span>Showing {displayedData.length} of {product.length} items</span>
                                <select
                                    value={itemsPerPage}
                                    onChange={handleItemsPerPageChange}
                                    className="border p-2 rounded ml-1"
                                >
                                    {ITEMS_PER_PAGE_OPTIONS.map((option) => (
                                        <option key={option} value={option}>
                                            {option} per page
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <table className="w-full border-collapse border border-gray-300">
                                <thead className="bg-gray text-white">
                                    <tr>
                                        <th className="border p-2">Product Code</th>
                                        <th className="border p-2">Product Name</th>
                                        {/* <th className="border p-2">UN No.</th>
                                        <th className="border p-2">IMCO</th> */}
                                        <th className="border p-2">CAS No.</th>
                                        <th className="border p-2">MSDS</th>
                                        <th className="border p-2">COAs</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayedData.map((item, index) => (
                                        <tr key={index} className="odd:bg-gray-100">
                                            <td className="border p-2 font-bold">{item.hs_code}</td>
                                            <td className="border p-2"><Link to={item.slug} className="text-title">{item.product_name}</Link></td>
                                            {/* <td className="border p-2">{item.un_no}</td>
                                            <td className="border p-2">{item.imco_class}</td> */}
                                            <td className="border p-2">{item.cas_no}</td>
                                            <td className="border p-2 text-blue-500 cursor-pointer">MSDS</td>
                                            <td className="border p-2 text-blue-500 cursor-pointer"><Link to={`http://admin.elementeers.com/core/public/pdfs/${item.msds_file}`} target="_blank">COAs</Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* Pagination */}
                            <div className="d-flex justify-content-end items-center space-x-2 mt-4">
                                <button
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className="px-3 py-1 mx-1 border bg-gray-200 rounded disabled:opacity-50"
                                >
                                    Prev
                                </button>
                                {[...Array(totalPages)].map((_, i) => (
                                    <button
                                        key={i}
                                        onClick={() => handlePageChange(i + 1)}
                                        className={`px-3 mr-1 py-1 border ${currentPage === i + 1 ? "bg-blue-500 text-white" : "bg-gray-200"} rounded`}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    className="px-3 py-1 mx-0 border bg-gray-200 rounded disabled:opacity-50"
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
